import _ from 'lodash';
import { PaginationRestDTO, PaginatedDataDTO, PaginationDTO } from '@bottega52/commons-pagination';
import { ICustomerContractInDTO } from '../repository/jago/model/input/ICustomerContractInDTO';
import { ICustomerContractFormDTO } from '../repository/jago/model/input/ICustomerContractFormDTO';
import { ICustomerInDTO } from '../repository/jago/model/input/ICustomerInDTO';
import { ICustomerContractOutDTO } from '../repository/jago/model/output/ICustomerContractOutDTO';

export function decode(data: PaginationRestDTO<ICustomerContractInDTO>): PaginatedDataDTO<ICustomerContractInDTO> {
    const pagination: PaginationDTO = _.omit(data, 'content');
    return {
      content: data.content,
      pagination,
    };
}

export enum CustomerContractStatusOptions {
  ACTIVE = 'ACTIVE',
  NOT_ACTIVE = 'NOT_ACTIVE',
  CANCELLED = 'CANCELLED',
}

export function decodeCustomerContractContentToForm(data: ICustomerContractInDTO, customers: ICustomerInDTO[]): ICustomerContractFormDTO {
  let foundCustomer = customers.filter(e=>e.id===data.customerId)
  return {
    id: data.id,
    name: data.name,
    status: data.status,
    signingDate: data.signingDate,
    expirationDate: data.expirationDate,
    activationDate: data.activationDate,
    deactivationDate: data.deactivationDate,
    customer: foundCustomer.length>0?foundCustomer[0]:null,
  };
}

export function encodeCustomerContractFromForm(data: ICustomerContractFormDTO): ICustomerContractOutDTO {
    let retVal: ICustomerContractOutDTO = {
      name: data.name,
      status: data.status,
      signingDate: data.signingDate,
      expirationDate: data.expirationDate,
      activationDate: data.activationDate,
      deactivationDate: data.deactivationDate,
      customerId: data.customer?.id,
    };
    return retVal;
}

export function encodeCustomerContractInFromOut(data: ICustomerContractInDTO): ICustomerContractOutDTO {
    return {
      name: data.name,
      status: data.status,
      signingDate: data.signingDate,
      expirationDate: data.expirationDate,
      activationDate: data.activationDate,
      deactivationDate: data.deactivationDate,
      customerId: data.customerId,
    };
}